common.View.create('website::layouts.main.Header', {

    setTotalPhysicalAmount(amount)
    {
        this.element

            .find('.cart')

            // Update amount.
            .find('.amount')
                .text(amount)
                .end()

            // Update label.
            .find('.label')
                .text(amount === 1 ? 'product' : 'producten')
                .end()

            .end();
    },

});
